export default __webpack_public_path__ + "static/media/btn_-chat_az.0e390ec7.png";